<template v-if="globaljs.mb_staff !== 'Worker'">
	<include-header-sub />

	<div class="modal_bg"></div>

	<section id="set_lab1">
		<div id="setting_page">
			<div class="setting_inner">
				<div class="setting_left">
					<div class="setting_tit">{{ other_type }} 찾기</div>
					<div class="lab_search">
						<input id="search" type="text" class="live-search-box" placeholder="검색어를 입력해주세요">
						<input id="search_btn" type="button" value="검색">
					</div>

					<ul :class="HZwrapper" class="lab_list match_list" id="hospital_list">
						<li v-for="(item, index) in items" :key="item.mb_boss_id" :class="HZlines" :data-id="item.mb_boss_id"
							data-show="Y" :style="getStyle(item)"
							:data-search-term="item.mb_nick + item.mb_busi_addr + item.mb_tel + '&nbsp;/&nbsp;' + item.mb_hp">
							<div>
								<p class="lab_tit">{{ item.mb_nick }}</p>
								<p class="lab_txt">{{ item.mb_busi_addr }}</p>
								<p class="lab_txt">{{ item.mb_tel }}&nbsp;/&nbsp;{{ item.mb_hp }}</p>
								<div class="select_btn select_btn1" :style="getBtn1(item)"
									@click="toggleCheck(item)">
									매칭 요청</div>
								<div class="select_btn select_btn2" :style="getBtn2(item)">{{ getStatusText(item) }}</div>
							</div>
						</li>
					</ul>

					<div class="nomatch_list">
						<p class="icon_notice_g"></p>
						<p>검색 결과가 존재하지 않습니다.</p>
					</div>
				</div>

				<div class="setting_right">
					<div class="setting_tit">{{ other_type }} 목록</div>
					<include-match-r :filteredItems="filteredItems" :checkedItems="checkedItems" :waitingItemsCount="waitingItems.length" @remove-partner="uncheck_item"/>
				</div>

			</div>
		</div>
	</section>

</template>

<script>
import header_sub from '../components/layout/header-sub.vue'
// import match_ok from '../components/layout/match_ok.vue'
import match_r from '../components/layout/match_r.vue'

export default {
	name: 'App',
	components: {
		'include-header-sub': header_sub,
		// 'include-matchok': match_ok,
		'include-match-r': match_r,
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as commonjs from '@/components/utils/common';
import * as globaljs from '@/components/utils/global';
import * as step1js from '@/components/utils/setting_step1';

const route = useRoute();
const router = useRouter();

if(globaljs.mb_staff === 'Worker') { commonjs.authSwal(); }

const today = moment().format('YYYY-MM-DD');

let other_type = ref(null);
if (globaljs.acc_type === 'lab') {
	other_type.value = "치과";
} else {
	other_type.value = "기공소";
}

const items = ref([]); // 아이템 리스트
const checkedItems = ref([]);

const HZwrapper = 'paginationTable';
const HZlines = 'tableItem';
const HZperPage = 10;
const HZpaginationId = 'pagination-container';
const HZpaginationArrowsClass = 'paginacaoCursor';
const HZpaginationCustomClass = 'customPagination';
const currentPage = ref(1);
const totalPages = computed(() => Math.ceil(items.value.length / HZperPage));

const paginatedItems = computed(() => {
	const start = (currentPage.value - 1) * HZperPage;
	const end = start + HZperPage;
	return items.value.slice(start, end);
});

const goToPage = (page) => {
	if (page > 0 && page <= totalPages.value) {
		currentPage.value = page;
	}
};

const previousPage = () => {
	if (currentPage.value > 1) {
		currentPage.value--;
	}
};

const nextPage = () => {
	if (currentPage.value < totalPages.value) {
		currentPage.value++;
	}
};

const pagesToShow = computed(() => {
	const pages = [];
	const totalPagesValue = totalPages.value;
	const currentPageValue = currentPage.value;
	const showPagesCount = 10; // 한번에 보여줄 페이지 번호 개수
	const halfShowPagesCount = Math.floor(showPagesCount / 2);

	let start = Math.max(1, currentPageValue - halfShowPagesCount);
	let end = Math.min(totalPagesValue, currentPageValue + halfShowPagesCount);

	if (currentPageValue <= halfShowPagesCount) {
		end = Math.min(totalPagesValue, showPagesCount);
	}

	if (currentPageValue > totalPagesValue - halfShowPagesCount) {
		start = Math.max(1, totalPagesValue - showPagesCount + 1);
	}

	for (let i = start; i <= end; i++) {
		pages.push(i);
	}

	return pages;
});

const commonCondition = (item) => {
	return checkedItems.value.some(checkedItem => checkedItem.mb_boss_id === item.mb_boss_id) ||
		filteredItems.value.some(filteredItem => filteredItem.mb_boss_id === item.mb_boss_id) ||
		item?.unmatched;
	};

const getStyle = (item) => {
	return commonCondition(item) ? { color: '#ccc' } : {};
};

const getBtn1 = (item) => {
	return commonCondition(item) ? { display: 'none' } : {};
};

const getBtn2 = (item) => {
	return commonCondition(item) ? { display: 'block' } : {};
};

const getStatusText = (item) => {
	if (item?.partner && Object.keys(item.partner).length > 0) {
		return '매칭 완료';
	} else if (item?.unmatched && Object.keys(item.unmatched).length > 0) {
		return '대기중';
	} else {
		return '선택 완료';
	}
};

const filteredItems = computed(() => {
	//return items.value.filter(item => showItem(item));
	return items.value.filter(item => item?.partner && Object.keys(item.partner).length > 0);
});

// const showItem = (item) => {
// return item.partner;
// };

const waitingItems = computed(() => {
	return items.value.filter(item => item.unmatched && Object.keys(item.unmatched).length > 0);
});

const check_item = (item) => {
	if (!checkedItems.value.some(checkedItem => checkedItem.mb_boss_id === item.mb_boss_id)) {
	checkedItems.value.push(item);
	}
};

const uncheck_item = (mb_boss_id) => {
	checkedItems.value = checkedItems.value.filter(item => item.mb_boss_id !== mb_boss_id);
};

const toggleCheck = (item) => {
	if (commonCondition(item)) {
		uncheck_item(item.mb_boss_id);
	} else {
		check_item(item);
	}
};

// partner와 unmatched가 모두 없는 항목의 개수를 계산하는 computed 속성
const unmatchedCount = computed(() => {
	return items.value.filter(item => !(item?.partner || (!item?.partner && item?.unmatched))).length;
});

onMounted(async () => {
	if(globaljs.mb_staff !== 'Worker') {
		await getModels();

		commonjs.DOMLoaded();
		step1js.DOMLoaded();

	console.log('매칭 가능수', unmatchedCount.value);
		if (unmatchedCount.value < 1) {
			commonjs.formSwal('거래처 없음', '매칭 요청을 할 거래처가 없습니다.', 'popup', 'error');
		}
	}
});

const getModels = async () => {
	const params = new URLSearchParams();
	// params.append('mb_id', globaljs.mb_id);
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/member/other`, { params });
console.debug(response.data.result);
		items.value = response.data.result;
	} catch (error) {
console.error('Error getModels:', error);
	}
}
</script>